import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  emailDomainsTab: {
    margin: "24px 0 0 0",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "24px 0px",
    }
  },
  details:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"space-between",
    marginTop: "32px",
    gap: "10px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display:"grid",
    }
  },
  txtDiv: {
    marginRight: "15px"
  },
  title:{
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    marginBottom:"4px",
    color: colors.lightBlack,
  },
  description:{
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
  },
  btnContainer:{
    display:"flex",
    flexDirection:"row",
    alignItems:"flex-start",
    whiteSpace: "nowrap",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginTop: "15px"
    }
  },
  button:{
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
  },
  dotsStyle:{
    display:"flex",
    alignItems:"center",
    marginLeft: "-4px",
    cursor: "pointer",
    "& path": {
      stroke: colors.greyNeutral
    },
    "&:hover": {
      "& path": {
        stroke: colors.black
      }
    },
    "&:focus": {
      "& path": {
        stroke: colors.black
      }
    },
  },
  dotsOpenStyle: {
    "& path": {
      stroke: colors.grey
    }
  },
  popoverStyle:{
    "& .popover-arrow": {
      display: "none !important",
    },
  },
  popoverDiv: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "flex-start",
    backgroundColor: colors.white,
    padding: "6px",
    width: "240px",
    border: `1px solid ${colors.lightGrey}`,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    position: 'absolute',
    borderRadius: 8,
    color: colors.grey,
    translate:"-231px -11px",
  },
  popoverAction: {
    padding: "10px",
    cursor: "pointer",
    width: "100%",
    color: colors.grey,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    "&:hover": {
      color: colors.grey,
      backgroundColor: colors.brightBlue,
      borderRadius: "8px"
    },
  },
  popoverActionDelete: {
    extend: "popoverAction",
    color: colors.darkRed,
    "&:hover": {
      color: colors.darkRed,
    },
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid " + colors.lightGrey,
    padding: "16px 0",
    "& p": {
      margin: 0,
    }
  },
  unverified: {
    fontSize: "12px",
    fontWeight: "500",
    color: colors.orange,
    background: colors.veryLightOrange,
    padding: "2px 8px",
    borderRadius: "16px",
    marginLeft: "12px",
    border: theme.pill.border,

  },
  domainsWrapper: {
    marginTop: "24px",
    paddingBottom: "48px",
    "& > :last-child": {
      borderBottom: "0px transparent"
    }
  },
  createdOn: {
    fontSize: "14px",
    fontWeight: "400",
    color: colors.mediumGrey,
    "& span": {
      marginLeft: "5px",
    }
  },
  domainName: {
    fontSize: "14px",
    fontWeight: "600",
    color: colors.grey,
    wordBreak: "break-word"
  },
  noData: {
    marginTop: "48px",
    display:"flex",
    flexDirection:"column",
    textAlign: "center",
    alignItems: "center",
    "& svg": {
      marginBottom: "16px"
    },
    "& path": {
      stroke: colors.primary600Blue
    }
  },
  noDataButton: {
    marginRight: "0px !important",
    padding: "10px 18px",
    fontSize: "16px",
    lineHeight: "24px"
  },
  noDataTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: colors.lightBlack,
    margin: 0,
  },
  noDataDescription: {
    fontSize: "14px",
    fontWeight: "400",
    color: colors.mediumGrey,
    marginBottom: "24px"
  },
  confirmationModal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight:"600",
      lineHeight:"28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight:"400",
      lineHeight:"20px",
    },
    "& .modal-body": {
      padding: "8px 24px 24px",
      wordBreak: "break-word"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  cancelButton: {
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    marginTop: "32px",
  },
  dotsButtonContainer:{
    display:"flex",
  },
  iconColor: {
    "& path": {
      stroke: theme.icon.stroke
    }
  }
}));

export default styles;
